import React from 'react';
import { Table, TableContainer, TableRow, TableBody } from '@mui/material';
import Sticky from 'react-stickynode';

import {
  ResponsiveTable,
  StyledButtons,
  StyledCatText,
  StyledCatTextName,
  StyledCheckIcon,
  StyledChip,
  StyledCloseIcon,
  StyledDescriptionText,
  StyledPlanBox,
  StyledTableCell,
  StyledTableCellCat,
  StyledTableCellCat1,
  StyledTableCellCatFeature,
  StyledTableCellCatFeatureText,
  StyledTableCellCatTitle,
  StyledTableCellPlan,
  StyledTableCellPlanBox,
  StyledTableCellPlanPrice,
  StyledTableCellPlanText,
  StyledTableContainer,
  StyledTableHead,
  StyledTitle,
  TableRows,
} from './PricingFeature.style';
import { useTokensTable } from './usePricingFeature';
import Link from 'next/link';
import { useTranslations } from 'hooks/useTranslations';
const PricingFeature = ({ plans, categories ,locale}) => {
  const { isBrowser, tableRef, stickyHeaderRef } = useTokensTable();
  const { t } = useTranslations();

  const renderCellValue = (value) => {
    if (value === true) return <StyledCheckIcon />;
    if (value === false) return <StyledCloseIcon />;
    return value;
  };
  return (
    <StyledTableContainer ref={tableRef}>
      <StyledTitle>{t('TokensTable.Title')}</StyledTitle>
      <StyledDescriptionText>
        {t('TokensTable.Description')}
      </StyledDescriptionText>
      <ResponsiveTable>
        <TableContainer>
          {isBrowser && (
            <Sticky top={140} bottomBoundary={tableRef.current} innerZ={999}>
              <Table>
                <StyledTableHead ref={stickyHeaderRef}>
                  <TableRows>
                    <StyledTableCell>
                      {t('TokensTable.fonction')}
                    </StyledTableCell>
                    {plans.map((plan) => (
                      <StyledTableCellPlan key={plan.id}>
                        <StyledTableCellPlanBox>
                          <StyledPlanBox>
                            <StyledTableCellPlanText>
                              {locale ==='en-us'? plan.name:plan.nameFR}
                            </StyledTableCellPlanText>
                            {plan.badge && (
                              <StyledChip>
                                <Link href="https://www.dri.fr/">
                                  {plan.badge}
                                </Link>
                              </StyledChip>
                            )}
                          </StyledPlanBox>
                          <StyledTableCellPlanPrice>
                            {plan.price.label ||
                              `${plan.price.amount?plan.price.amount:'0'} ${plan.price.currency}/Month`}
                          </StyledTableCellPlanPrice>
                          <StyledButtons
                            onClick={() =>
                              (window.location.href =
                                'https://www.app.swiftask.ai/')
                            }
                          >
                            {locale ==='en-us'? plan.cta:plan.ctaFR}
                          </StyledButtons>
                        </StyledTableCellPlanBox>
                      </StyledTableCellPlan>
                    ))}
                  </TableRows>
                </StyledTableHead>
              </Table>
            </Sticky>
          )}

          <Table>
            <TableBody>
              {categories.map((category, categoryIndex) => (
                <React.Fragment key={category.name}>
                  {categoryIndex > 0 && (
                    <TableRow>
                      <StyledTableCellCatTitle colSpan={plans.length + 1} />
                    </TableRow>
                  )}
                  <TableRow>
                    <StyledTableCellCat1 colSpan={plans.length + 1}>
                            <StyledCatText>{locale ==='en-us'? category.name:category.nameFR}</StyledCatText>
                      <StyledCatTextName>
                      {locale ==='en-us'? category.description:category.descriptionFR}
                      </StyledCatTextName>
                    </StyledTableCellCat1>
                  </TableRow>
                  {category.features.map((feature) => (
                    <TableRow key={feature.name}>
                      <StyledTableCellCat>
                        <StyledCatTextName> {feature.name}</StyledCatTextName>
                      </StyledTableCellCat>
                      {plans.map((plan) => (
                        <StyledTableCellCatFeature key={plan.id}>
                          {feature.values.map((value, index) => (
                            <StyledTableCellCatFeatureText key={index}>
                              {renderCellValue(value[plan.name.toLowerCase()])}
                            </StyledTableCellCatFeatureText>
                          ))}
                        </StyledTableCellCatFeature>
                      ))}
                    </TableRow>
                  ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ResponsiveTable>
    </StyledTableContainer>
  );
};

export default PricingFeature;
